module.exports = __webpack_public_path__ + "static/media/4.045b6a2a.jpg";